import { useEffect, useRef } from "react";

const UPLOAD_TIMEOUT_MS = 60_000;

export const useUploadTimeouts = (onTimeout: (documentId: string) => void) => {
  const timeoutsRef = useRef<Map<string, ReturnType<typeof setTimeout>>>(new Map());
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  const startUploadTimeout = (documentId: string) => {
    const timeout = setTimeout(() => {
      timeoutsRef.current.delete(documentId);
      onTimeoutRef.current(documentId);
    }, UPLOAD_TIMEOUT_MS);
    timeoutsRef.current.set(documentId, timeout);
  };

  const clearUploadTimeout = (documentId: string) => {
    const timeout = timeoutsRef.current.get(documentId);
    if (timeout !== undefined) {
      clearTimeout(timeout);
      timeoutsRef.current.delete(documentId);
    }
  };

  useEffect(() => {
    return () => {
      for (const timeout of timeoutsRef.current.values()) {
        clearTimeout(timeout);
      }
    };
  }, []);

  return { startUploadTimeout, clearUploadTimeout };
};
